<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Tìm kiếm nâng cao</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-info btn-sm fas fa-search" (click)="submit()" style="float: right; margin-right: 5px;">
                    Thống kê dữ liệu <i class="fas fa-search"></i>
                </button>
                <button class="btn btn-warning btn-sm"  type="submit" style="float: right;margin-right: 5px; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="filter">
                <div class="row">
                    <div class="col-md-2 ">
                        <label style="margin-left: 15px;">Hệ</label>
                        <select class="form-control" (change)="changeHe()" formControlName="ID_he">
                            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label style="margin-left: 15px;">Khoa</label>
                        <select class="form-control" formControlName="ID_khoa" (change)="changeKhoa()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoa" value="{{i.ID_khoa}}">{{i.Ten_khoa}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label style="margin-left: 15px;">Khóa</label>
                        <select class="form-control" formControlName="Khoa_hoc" (change)="change()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoaHoc" value="{{i.Khoa_hoc}}">{{i.Khoa_hoc}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label style="margin-left: 15px;">Chuyên ngành</label>
                        <select class="form-control" formControlName="ID_chuyen_nganh" (change)="change()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataChuyenNganh" value="{{i.ID_chuyen_nganh}}">{{i.Chuyen_nganh}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label style="margin-left: 15px;">Lớp</label>
                        <select class="form-control" formControlName="ID_lop">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataLop" value="{{i.ID_lop}}">{{i.Ten_lop}}</option>
                        </select>
                    </div>
                    <div class="col-md-2" >
                        <label style="margin-left: 15px;">Nhóm tìm kiếm</label>
                        <select class="form-control" formControlName="Hien_thi">
                            <option *ngFor="let i of dtHienThi" value="{{i.FieldGroup}}">{{i.GroupName}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 ">
                        <label style="margin-left: 15px;margin-top: 10px;">Điều kiện 1</label>
                        <select class="form-control"  formControlName="Dieu_kien1">
                        </select>
                    </div>
                    <div class="col-md-2 ">
                        <label style="margin-left: 15px;margin-top: 10px;">Toán tử</label>
                        <select class="form-control" formControlName="Toantu1">
                        </select>
                    </div>
                    <div class="col-md-2 ">
                        <label style="margin-left: 15px;margin-top: 10px;">Giá trị 1</label>
                        <select class="form-control" formControlName="Giatri1"> </select>
                    </div>
                    <div class="col-md-2 " >
                        <label style="margin-left: 15px;margin-top: 10px;">Giá trị 2</label>
                        <select class="form-control" formControlName="Giatri2" ></select>
                    </div>
                    <div class="col-md-2" style="margin-top: 30px;">
                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike">
                           <label style="margin-left: 10px;">Chỉ hiển thị bản ghi có dữ liệu</label>
                       </div>
                        <div class="col-md-2" style="margin-top: 15px;">
                            <label style="margin-left: 15px;">Nhóm hiển thị</label>
                            <select class="form-control" formControlName="Hien_thi">
                                <option *ngFor="let i of dtHienThi" value="{{i.FieldGroup}}">{{i.GroupName}}</option>
                            </select>
                        </div>
                </div>
            </form>
        </div>
    </div>
</section>
<section class="content cus-body" *ngIf="isDisplay">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 60vh;">
                <table class="table table-bordered" style="width: 100%;">
                    <thead>
                        <tr *ngFor="let i of dataHeader">
                            <th *ngFor="let value of i.Cells" [attr.colspan]="value.Colspan"
                                [attr.rowspan]="value.Rowspan">
                                {{value.Name}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let i of dataTable">

                            <td *ngFor="let value of i.Value"
                                [ngStyle]="{'font-weight':value.Bold != true ? '0' :'bold','text-align':value.Format}">
                                {{value.Value}}
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body" *ngIf="!isDisplay">
    <div class="card">
        <div class="card-body">
            <div id="chartContainer" style="height: 370px; width: 100%;"></div>
        </div>
    </div>
</section>